import 'css-chunksrc/client/scenes/workloads/detailsView/details/dates/styles.scss';export default {
  "details": "_details_hnekn_1",
  "list": "_list_hnekn_16",
  "block": "_block_hnekn_20",
  "readOnly": "_readOnly_hnekn_31",
  "calendar": "_calendar_hnekn_42",
  "text": "_text_hnekn_51",
  "recalculated": "_recalculated_hnekn_60",
  "project": "_project_hnekn_65",
  "closedCalendar": "_closedCalendar_hnekn_73"
};